import { IntentObj } from '../../types/caf';

const InputProcessor = {
  /**
     * format & anitize the user intent
     * @param intentName what is user's desired intent
     * @returns an object of intent
     */
  getIntents: function (intentName: string): IntentObj {
    return {
      intentName: intentName
    };
  }
};

export default InputProcessor;
